import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    filters: [],
    searchMeta: null,
    fuelGrades: [],
    stateFuelPrice: [],
    acknowledgementStatus: [],
};

const getters = {
    fuelGrades(state) {
        return state.fuelGrades;
    },

    filters(state) {
        return state.filters;
    },

    stateFuelPrice(state) {
        return state.stateFuelPrice;
    },

    acknowledgementStatus(state) {
        return state.acknowledgementStatus;
    },
};

const mutations = {
    setFuelGrades(state, data) {
        state.fuelGrades = data;
    },

    setStateFuelPrice(state, data) {
        state.stateFuelPrice = data;
    },

    setAcknowledgementStatus(state, data) {
        state.acknowledgementStatus = data;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },
};

const actions = {
    getFuelGradeList({ commit, dispatch }) {
        startLoading(dispatch, 'get-fuel-price-fuelgrades');

        return axios
            .get(Laroute.route('franchise.inventory.fuel.fuels'))
            .then(res => {
                commit('setFuelGrades', res.data);
                endLoading(dispatch, 'get-fuel-price-fuelgrades');

                return res.data;
            });
    },

    getFuelGrades({ dispatch }) {
        if (!state.fuelGrades.length) {
            return dispatch('getFuelGradeList');
        }

        return Promise.resolve(state.fuelGrades);
    },

    getSearchMeta({ commit, dispatch }) {
        startLoading(dispatch, 'get-fuel-price-meta');

        return axios
            .get(Laroute.route('franchise.inventory.fuel.fuelset.meta'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-fuel-price-meta');
                return res.data;
            });
    },

    getSearchAcknowledgementMeta({ commit, dispatch }) {
        startLoading(dispatch, 'get-site-acknowledgement-meta');

        return axios
            .get(
                Laroute.route(
                    'franchise.inventory.fuel.site-acknowledgement.meta',
                ),
            )
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-site-acknowledgement-meta');
                return res.data;
            });
    },

    getSearchMetaIfNecessary({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getStateFuelPriceList({ commit, dispatch }) {
        startLoading(dispatch, 'fetch-state-fuel-price');

        return axios
            .get(
                Laroute.route(
                    'franchise.inventory.fuel.fuelset.state-fuel-price',
                ),
            )
            .then(res => {
                let data = res.data.data;

                commit('setStateFuelPrice', data);
                endLoading(dispatch, 'fetch-state-fuel-price');

                return data;
            });
    },

    getStateFuelPrice({ dispatch }) {
        if (!state.stateFuelPrice.length) {
            return dispatch('getStateFuelPriceList');
        }

        return Promise.resolve(state.stateFuelPrice);
    },

    getAcknowledgementStatusList({ commit, dispatch }) {
        startLoading(dispatch, 'fetch-acknowledgement-status');

        return axios
            .get(
                Laroute.route(
                    'franchise.inventory.fuel.site-acknowledgement.status',
                ),
            )
            .then(res => {
                let data = res.data.data;

                commit('setAcknowledgementStatus', data);
                endLoading(dispatch, 'fetch-acknowledgement-status');

                return data;
            });
    },

    getAcknowledgementStatus({ dispatch }) {
        if (!state.acknowledgementStatus.length) {
            return dispatch('getAcknowledgementStatusList');
        }

        return Promise.resolve(state.acknowledgementStatus);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
